import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GeolocationService } from './geolocation.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [GeolocationService]
})
export class GeolocationModule {}
